import { SendMessageFromHttpActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/SendMessageFromHttpActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
export class HttpContentController extends ActionController {
    static $inject = ['action', 'close', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope', '$scope'];
    constructor(action, close, $onStateChanged, UndoRedoService, state, $rootScope, $scope) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope });
        this.onChangeUri = (event) => {
            this.action.settings.uri = event.detail?.value;
        };
    }
    create() {
        return new SendMessageFromHttpActionSettings();
    }
    async setBuilderType() {
        switch (this.action.settings.$builderType) {
            case BuilderContentType.DocumentSelect:
                this.action.settings.type = 'application/vnd.lime.collection+json';
                break;
            case BuilderContentType.Select:
            case BuilderContentType.SelectImmediate:
                this.action.settings.type = 'application/vnd.lime.select+json';
                break;
            default:
                this.action.settings.type = 'text/plain';
                break;
        }
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
}
HttpContentController.$inject = ['action', 'close', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope', '$scope'];
